module.exports = __webpack_public_path__ + "assets/img/img.b419a296.png";